export default {
  title: 'Sistemski dnevnici',
  source: 'Povezano sa instancom: {{instanceId}} · Fajl: {{fileName}}',
  instances: 'Instance',
  localInstance: '{{instanceId}} (povezano)',
  instanceLost: 'Ova instanca je prestala da šalje svoj dnevnik (ugašena je ili nedostupna)',
  status: {
    connecting: 'Povezivanje...',
    connected: 'Uživo',
    disconnected: 'Prekinuta veza',
  },
  searchPlaceholder: 'Filtriraj redove...',
  levels: {
    error: 'Greška',
    warn: 'Upozorenje',
    info: 'Informacija',
    debug: 'Otklanjanje grešaka',
  },
  httpRequests: 'HTTP zahtjevi',
  httpRequestsTitle: 'Prikaži ili sakrij redove koji bilježe HTTP zahtjeve koje je server obradio',
  maxLines: 'Maks. redova',
  pause: 'Pauziraj',
  resume: 'Nastavi ({{count}} novih)',
  export: 'Izvezi',
  exportTitle: 'Preuzmi sve učitane redove (bez primijenjenih filtera) u tekstualni fajl',
  clear: 'Obriši',
  reconnect: 'Ponovo se poveži',
  jumpToLatest: 'Idi na najnovije',
  fileNotFound: 'Instanca {{instanceId}}: fajl dnevnika {{fileName}} nije pronađen, čeka se da bude kreiran',
  linesCount: 'Prikazano {{visible}} od {{total}} redova',
  markers: {
    rotated: 'fajl dnevnika je rotiran',
    skipped: 'upisano je previše redova: neki redovi su preskočeni',
    truncated: 'stariji redovi nisu učitani',
  },
}
